import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ChangeDetectorRef
} from '@angular/core'
import { notNullOrUndefined } from '@vendure/common/lib/shared-utils'
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker'
import { NotificationService } from '../../../providers/notification/notification.service'
import { ServerConfigService } from '../../../data/server-config'

@Component({
  selector: 'vdr-image-input',
  templateUrl: './image-input.component.html',
  styleUrls: ['./image-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageInputComponent implements OnInit {
  @Input() dropZoneTarget = 'body'
  @Input() uploading = false
  @Output() selectFiles = new EventEmitter<File[]>()
  @Input() readonly = false
  dragging = false
  overDropZone = false
  dropZoneStyle = {
    'width.px': 0,
    'height.px': 0,
    'top.px': 0,
    'left.px': 0
  }
  accept: string
  previewImage: string | null = null
  @Input() image: string | null = null

  constructor(
    private serverConfig: ServerConfigService,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.accept = this.serverConfig.serverConfig.permittedAssetTypes.join(',')
    this.fitDropZoneToTarget()
  }

  @HostListener('document:dragenter')
  onDragEnter() {
    this.dragging = true
    this.fitDropZoneToTarget()
  }

  @HostListener('document:dragleave', ['$event'])
  onDragLeave(event: any) {
    if (!event.clientX && !event.clientY) {
      this.dragging = false
    }
  }

  onDragOver(event: any) {
    event.preventDefault()
  }

  onDrop(event: any) {
    event.preventDefault()
    this.dragging = false
    this.overDropZone = false
    const files = Array.from<DataTransferItem>(
      event.dataTransfer ? event.dataTransfer.items : []
    )
      .map((i) => i.getAsFile())
      .filter(notNullOrUndefined)

    if (files.length > 0) {
      const file = files[0]
      if (!file.type.startsWith('image/')) {
        this.notificationService.error(_('asset.notify-upload-error'), {
          entity: _('marketing.promotion')
        })
        return
      }

      this.selectFiles.emit(files)
      const reader = new FileReader()
      reader.onload = (e) => {
        this.previewImage = e.target?.result as string
        this.cdr.markForCheck()
      }
      reader.readAsDataURL(file)
    }
  }

  select(event: Event) {
    const files = (event.target as HTMLInputElement).files
    if (files && files.length > 0) {
      this.selectFiles.emit(Array.from(files))
      const reader = new FileReader()
      reader.onload = (e) => {
        this.previewImage = e.target?.result as string
        this.cdr.markForCheck()
      }
      reader.readAsDataURL(files[0])
    }
  }

  private fitDropZoneToTarget() {
    const target = document.querySelector(this.dropZoneTarget) as HTMLElement
    if (target) {
      const rect = target.getBoundingClientRect()
      this.dropZoneStyle['width.px'] = rect.width
      this.dropZoneStyle['height.px'] = rect.height
      this.dropZoneStyle['top.px'] = rect.top
      this.dropZoneStyle['left.px'] = rect.left
    }
  }
}
